// extracted by mini-css-extract-plugin
module.exports = {"main":"reset-page_main__1IrJL","form":"reset-page_form__2FM4H","nav":"reset-page_nav__3mk1_","link":"reset-page_link__F32z4"};